import { SET_ALL, ADD_LOGIN_HISTORY_DATA_ALL, LESS_LOGIN_HISTORY_DATA_ALL } from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [ADD_LOGIN_HISTORY_DATA_ALL](state, data) {
    state.loginHistoryDataAll = state.loginHistoryDataAll.concat(data);
    return state.loginHistoryDataAll;
  },
  [LESS_LOGIN_HISTORY_DATA_ALL](state) {
    const loginHistoryDataAll = state.loginHistoryDataAll.splice(0, 5);
    Object.assign(state, { loginHistoryDataAll });
    return state.loginHistoryDataAll;
  },
};
